(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  const menuButton = document.querySelector('.vlc-header__menu-button');
  const menu = document.querySelector('#VlcMobileMenu');
  const closeButton = document.querySelector('.vlc-mobile-menu__close');
  const desktopDropdowns = document.querySelectorAll('.vlc-nav-dropdown');

  if (menuButton && menu && closeButton) {
    const closeMenu = () => {
      menu.hidden = true;
      menuButton.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    };

    menuButton.addEventListener('click', () => {
      menu.hidden = false;
      menuButton.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    });

    closeButton.addEventListener('click', closeMenu);

    menu.addEventListener('click', (event) => {
      if (event.target.closest('a')) closeMenu();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !menu.hidden) closeMenu();
    });
  }

  desktopDropdowns.forEach((dropdown) => {
    dropdown.addEventListener('toggle', () => {
      if (!dropdown.open) return;

      desktopDropdowns.forEach((otherDropdown) => {
        if (otherDropdown !== dropdown) {
          otherDropdown.removeAttribute('open');
        }
      });
    });
  });

  document.addEventListener('click', (event) => {
    desktopDropdowns.forEach((dropdown) => {
      if (!dropdown.contains(event.target)) {
        dropdown.removeAttribute('open');
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
